import { render, staticRenderFns } from "./casetext.vue?vue&type=template&id=3ccd2ff9&scoped=true&"
import script from "./casetext.vue?vue&type=script&lang=js&"
export * from "./casetext.vue?vue&type=script&lang=js&"
import style0 from "./casetext.vue?vue&type=style&index=0&id=3ccd2ff9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccd2ff9",
  null
  
)

export default component.exports